import { render, staticRenderFns } from "./shopee6.vue?vue&type=template&id=cb6d321c&scoped=true&"
import script from "./shopee6.vue?vue&type=script&lang=js&"
export * from "./shopee6.vue?vue&type=script&lang=js&"
import style0 from "./shopee6.vue?vue&type=style&index=0&id=cb6d321c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb6d321c",
  null
  
)

export default component.exports